import AbstractModelType from '../AbstractModelType';

class UserContentShare extends AbstractModelType {
  #sharer;
  #sharingCode;
  #isPaused;

  constructor(properties = {}) {
    super(...arguments);

    this.#sharer = properties.sharer;
    this.#sharingCode = properties.sharingCode;
    this.#isPaused = properties.isPaused;
  }

  get sharer() {
    return this.#sharer;
  }

  get sharingCode() {
    return this.#sharingCode;
  }

  get isPaused() {
    return this.#isPaused;
  }
}

export default UserContentShare;
